module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-3-5507bf2b32c3a6bb3f64e8229160f222.jpg";